import { Button, Cascader, Empty, Form, Input, Modal, Pagination, Spin } from "antd";
import { useCallback, useEffect, useState } from "react";
import "./index.less";
import { saveQuestions, getQuestions, getQuestionCategory } from "@/api/questions";
import account from "@/api/account";
import { updateMessageNum } from "@/utils/common";
import QuestionForm from "./components/QuestionForm";
import QuestionCard from "@/components/QuestionCard";

const Questions = () => {
  const [questionForm] = Form.useForm();
  const [list, setList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState(0);
  const [showEmpty, setShowEmpty] = useState(false);
  const [questionListLoading, setQuestionListLoading] = useState(false);//问题列表加载状态
  const [showQuestionForm, setShowQuestionForm] = useState(false);//是否展示提问表单
  const confirm =  () => {

          const formData = questionForm.getFieldsValue();
          const params={
            ...formData,
            typeId:formData.typeId[0]
          }
          
          saveQuestions({ ...params, isPublic: true }).then((res: any) => {
            if (res.code === 200) {
              setIsModalOpen(true);
              updateMessageNum();
              closeQuestionForm();
              questionForm.resetFields();
            }else{
              window.message.error(res?.message);
            }
          }).catch((err) =>{
            console.error(err);
            window.message.error(err?.message || '提问失败');
          });
  };

  const [categoryValue, setCategoryValue] = useState<any>('');
  const [categoryOptions,setCategoryOptions]= useState<any[]>([]);
  const onChange= (value:any) => {
    console.log(value);
    if(value&& value.length>0){
      setCategoryValue(value[0]);
    }else{
      setCategoryValue('');
    }
    
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const getList = (current:number,keyword:string=searchValue,typeId:string=categoryValue) => {
    
    setQuestionListLoading(true);
    setShowEmpty(false);
    getQuestions({
      pageNumber: current, // 当前页数
      pageSize: 5, // 页面大小
      keyword: keyword,
      typeId:typeId
    }).then((res: any) => {
      if (res.code === 200) {
        setList(res.result.records);
        setTotal(res.result.total);
        setCurrent(res.result.current);
        setShowEmpty(res.result.total==0);
        
      }
    }).catch((err) => {
      console.error(err);
    }).finally(()=>{
      setTimeout(() => {
        setQuestionListLoading(false);
      }, 300);
    })
    ;
  };

  const paginationChange = (e: number) => {
    console.log(e);
    
    getList(e);
    
    //存储 分页 页码
    // window.localStorage.setItem(current_key,`${e}`);
  };
  const [searchValue,setSearchValue]=useState('');//搜索输入框值
  /**
   * 修改搜索输入框值
   * @param e 
   */
  const changeSearchValue=(e:any)=>{
    console.log(e.target.value);
    setSearchValue(e.target.value);
  }
  /**
   * 清空搜素条件
   */
  const clearSearchParams = () => {
    setCategoryValue('');
    setSearchValue('');
    getList(1,'','');
  }
  /**
   * 获取问答分类列表
   */
  const getCategoryValue = () => {
    getQuestionCategory().then((res: any) => {
      if (res.code === 200) {
        console.log("getCategoryValue", res);
        setCategoryOptions(res.result.map((item: any) =>{
          return ({
            value: item.id,
            label: item.typeName,
          })
        }));
      }else{
        window.message.error(res?.message);
      }
    })
  }
  /**
   * 发起提问
   */
  const sponsorQuestion=useCallback(()=>{
    account.getUserDetail().then((res:any)=>{
      if(res.code==200 && res.data){
        setShowQuestionForm(true);
      }
  })
    
  },[])
  const closeQuestionForm=useCallback(()=>{
      setShowQuestionForm(false);
      questionForm.resetFields();
  },[])
  /**
   * 搜索问答
   */
  const searchQuestions = () => {
    clearList();
    getList(1);
  }
  /**
   * 清空问答列表
   */
  const clearList= ()=>{
    setList([]);
    setCurrent(1);
    setTotal(0);
  }
  useEffect(() => {
    getCategoryValue();
    getList(1);
    console.log("questions",window.tinymce);
  }, []);
    
  return (
    <div className="questions-banner-wrap">
      {
        showQuestionForm?<QuestionForm 
        form={questionForm}
        saveQuestion={confirm}
        categoryOptions={categoryOptions} 
        navEvent={closeQuestionForm}/>: <div className="questions-wrap" >
        <div className="questions-right">
          <div className="questions-right-title">
            <div className="questions-right-title-text">
              <div>获取帮助</div>
              <div>
              请告诉我们您的问题，我们将尽快为您提供解答。
              </div>
            </div>
            <Button type="primary" onClick={sponsorQuestion}>我要提问</Button>
          </div>
          <Form onFinish={searchQuestions}>
          <div className="questions-right-search">
            
              <div className="questions-right-search-category">
              <Cascader 
                className={"questions-right-search-category-select"}
                popupClassName={"questions-right-search-category-select-popup"}
                value={categoryValue}
                options={categoryOptions} 
                onChange={onChange} 
                placeholder="请选择分类" 
              />
              </div>
              <div className="questions-right-search-input">
                <Input maxLength={100} value={searchValue} onChange={changeSearchValue} placeholder="请输入关键词" />
                
              </div>
              <div className="questions-right-search-btn">

                <Button type="primary" loading={questionListLoading} htmlType="submit">搜索</Button>
                <Button onClick={clearSearchParams}>清空</Button>
              </div>
            
            

          </div>
          </Form>
          <Spin spinning={questionListLoading}>
          {
            showEmpty ? 
            <Empty image={<img src={require("@/assets/images/message/empty.png")}></img>}/> : 
            <div className="questions-right-content">
              {list.map((item: any) => {
                return (
                  <QuestionCard
                    item={item}
                    key={item.id}
                    type="feedback"
                    keyWord={searchValue}
                  />
                );
              })}
            </div>
          }
          <div>
            <Pagination
              pageSize={5}
              current={current}
              showSizeChanger={false}
              total={total}
              rootClassName="pagination"
              onChange={paginationChange}
            />
          </div>
          </Spin>
        </div>


      </div>
      }
        <Modal className="questions-modal" open={isModalOpen}>
          <div className="questions-modal-content">您的问题已提交，请留意消息中心站内信，谢谢！</div>
          <div className="questions-modal-confirm" onClick={handleOk}>
            确定
          </div>
        </Modal>
    </div>
  );
};

export default Questions;
